import { render } from "./dms_summary_report.vue?vue&type=template&id=65358f10&scoped=true"
import script from "./dms_summary_report.js?vue&type=script&lang=js"
export * from "./dms_summary_report.js?vue&type=script&lang=js"

import "./dms_summary_report.vue?vue&type=style&index=0&id=65358f10&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65358f10"]])

export default __exports__